import React from 'react'
import { useTrans } from 'hooks'
import { Button } from 'components/atoms'
import { FormRegistrazione, Page } from 'components/organisms'

const RegistrazioneTemplate = ({ pagina }) => {
  const t = useTrans()

  return (
    <Page
      hideBreadcrumbs
      pagina={pagina}
      containerVariant="md"
      contentStyle="basic"
      className="registrazione-template"
    >
      <FormRegistrazione />
      <div className="registrazione-template__bottom">
        <p className="registrazione-template__login-link">
          Hai già un account?{' '}
          <Button href="/login" label={t('Effettua il login')} variant="ghost" size="sm" />
        </p>
      </div>
    </Page>
  )
}

export default RegistrazioneTemplate
